'use client';

import { useState } from 'react';

export const useLogic = () => {
  const [tmpToken, setTmpToken] = useState<string>('');

  return {
    tmpToken,
    setTmpToken,
  };
};
